export default {
  GET_ABOUT_US(state, payload) {
    state.aboutUs = payload;
  },
  SELECTED_ABOUT_US(state, payload) {
    state.selectedAboutUs = payload;
  },
};
